import * as Firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

export const firebase = Firebase.initializeApp({
  apiKey: "AIzaSyAQgQUiTg9JnlkvuYX257Jtj-tn9IFgOSU",
  authDomain: "mwp-dash.firebaseapp.com",
  databaseURL: "https://mwp-dash.firebaseio.com",
  projectId: "mwp-dash",
  storageBucket: "mwp-dash.appspot.com",
  messagingSenderId: "129663279165"
});

// eslint-disable-next-line
export const db = firebase.firestore();


